export class LoggerString {
  constructor(public message: string) {}
}
